import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";

import { ResultAssessmentsChart } from "./ResultAssessmentsChart";

export const ResultAssessments = ({ assessmentResult }) => {
  const { focusAreaScores, total } = assessmentResult;
  return (
    <>
      <Grid container spacing={3}>
        {focusAreaScores.map((focusAreaScore) => (
          <Grid item sm={3} xs={12} key={`tab-${focusAreaScore.focusAreaId}`}>
            <ResultAssessmentsChart
              key={`chart-${focusAreaScore.focusAreaId}`}
              label={focusAreaScore.focusAreaName}
              total={focusAreaScore.score}
            />
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ResultAssessmentsChart
            label="MY FINANCIAL WELLNESS SCORE"
            total={total}
          />
        </Grid>
      </Grid>
    </>
  );
};

ResultAssessments.propTypes = {
  assessmentResult: PropTypes.shape({
    focusAreaScores: PropTypes.arrayOf(
      PropTypes.shape({
        focusAreaId: PropTypes.number.isRequired,
        focusAreaName: PropTypes.string.isRequired,
        maxScore: PropTypes.number.isRequired,
        score: PropTypes.number.isRequired,
        updatedScore: PropTypes.number.isRequired,
      })
    ).isRequired,
    total: PropTypes.number.isRequired,
    updatedTotalScore: PropTypes.number.isRequired,
  }).isRequired,
};
